const production = process.env.NODE_ENV === 'production' && process.env.REACT_APP_GTAG_TRACK_ID !== ''

export function gtagPageView(pageTitle, pagePath) {
  if (production) {
    const gtag = window.gtag
    gtag('config', process.env.REACT_APP_GTAG_TRACK_ID, {
      'page_title': pageTitle, 'page_path': `/credito-digital${pagePath}`,
      'linker': {
        'domains': [process.env.REACT_APP_GTAG_DOMAIN_LINKER]
      }
    })
  }
}

export function gtagOKEvent(eventTitle, eventLabel) {
  if (production) {
    const gtag = window.gtag
    gtag('event', eventTitle, { 'event_category': 'Credito Digital', 'event_label': eventLabel })
  }
}

export function gtagErrorEvent(eventTitle, eventLabel, errorName) {
  if (production) {
    const gtag = window.gtag
    gtag('event', eventTitle, { 'event_category': 'Credito Digital', 'event_label': `${eventLabel}: ${errorName}`})
  }
}

export function gtagPurchaseEvent(simulationId, amount, cuotas) {
  if (production) {
    const gtag = window.gtag
    gtag('event', 'Solicitud de Crédito Ingresada', { 'event_category': 'Credito Digital', 'event_label': 'Monto', 'value': amount })
    gtag('event', 'Solicitud de Crédito Ingresada', { 'event_category': 'Credito Digital', 'event_label': 'Cuotas', 'value': cuotas })
  }
}
